import React from 'react';
import columns from './columns';
import PreviewStepBase from '../../base/PreviewStepBase';
import { ASSET_ALIAS_FIELD, useCsvPreviewDataSource } from '../../base/useCsvPreviewDataSource';

export interface WorkOrderPreviewStepProps {
  mapping: Record<string, string>;
  csvTopLines: string[][];
}

const WorkOrderPreviewStep: React.FC<WorkOrderPreviewStepProps> = ({ mapping, csvTopLines }) => {
  const columnsFields = React.useMemo(() => Object.values(columns).map((col) => col.dataField), []);

  const dataSource = useCsvPreviewDataSource(
    mapping,
    csvTopLines,
    columnsFields,
    {
      field: 'state',
      value: 'Open',
    },
    ASSET_ALIAS_FIELD,
  );

  return (
    <PreviewStepBase
      infoText={
        <>
          Here is a preview of how your new work orders will look like in the Work Orders Table. You
          can go back and edit your columns if needed before submitting.
        </>
      }
      dataGridId="workorder-data-import-preview"
      pluralText="Work Orders"
      singularText="Work Order"
      columns={columns}
      dataSource={dataSource}
    />
  );
};

export default React.memo(WorkOrderPreviewStep);
